function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import React, { Component } from 'react';
import { View } from "../../../native";
import * as R from 'unitx/ramda';
import { getUiOptions, getWidget, guessType, retrieveSchema // filterRequiredPropertiesFromSchema,
, getDefaultFormState, getMatchingOption // deepEquals,
} from "../../utils";
import validate, { toErrorList } from "../../validate";
const replaceRef = R.replace('#/definitions/', '');
const getOptionNameList = R.mapIndexed((option, index) => R.cond([[R.has('title'), R.prop('title')], [R.has('type'), R.prop('type')], [R.has('$ref'), () => replaceRef(option.$ref)], [R.T, () => `Option ${index}`]])(option)); // type AnyOfFieldProps = {
// }
// function AnyOfField(props: AnyOfFieldProps) {
//   return (
//   )
// }

class AnyOfField extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onOptionChange", option => {
      const selectedOption = parseInt(option, 10);
      const {
        formData,
        onChange,
        options,
        registry
      } = this.props;
      const {
        definitions,
        rootSchema
      } = registry;
      const newOption = retrieveSchema(options[selectedOption], rootSchema, formData); // If the new option is of type object and the current data is an object,
      // discard properties added using the old option.

      let newFormData; // /////////CHANGED***

      if (guessType(formData) === 'object' && (newOption.type === 'object' || newOption.properties)) {
        newFormData = _objectSpread({}, formData);
        const optionsToDiscard = options.slice();
        optionsToDiscard.splice(selectedOption, 1); // @TODO:CHANGE
        // Discard any data added using other options
        // for (const option of optionsToDiscard) {
        //   if (option.properties) {
        //     for (const key in option.properties) {
        //       if (newFormData.hasOwnProperty(key)) {
        //         delete newFormData[key]
        //       }
        //     }
        //   }
        // }

        const validation = validate(newFormData, newOption);
        R.map(({
          dataPath
        }) => {
          newFormData = R.dissocPath(R.remove(0, 1)(R.split('/')(dataPath)))(newFormData);
        })(toErrorList(validation.errorSchema)); // @TODO:CHANGE_END
      } // Call getDefaultFormState to make sure defaults are populated on change.


      onChange(getDefaultFormState(options[selectedOption], newFormData, rootSchema)); // /////////***CHANGED

      this.setState({
        selectedOption: parseInt(option, 10)
      });
    });

    const {
      formData: _formData,
      options: _options
    } = this.props;
    this.state = {
      selectedOption: this.getMatchingOption(_formData, _options)
    };
  } // componentDidUpdate(prevProps, prevState) {
  //   if (
  //     !deepEquals(this.props.formData, prevProps.formData)
  //     && this.props.idSchema.$id === prevProps.idSchema.$id
  //   ) {
  //     const matchingOption = this.getMatchingOption(
  //       this.props.formData,
  //       this.props.options,
  //     )
  //     if (!prevState || matchingOption === this.state.selectedOption) {
  //       return
  //     }
  //     this.setState({
  //       selectedOption: matchingOption,
  //     })
  //   }
  // }


  getMatchingOption(formData, options) {
    // @TODO:TEST
    // const { definitions } = this.props.registry
    // ajv.validate(schemaKeyRef, data)
    // const option = R.reduceIndexed(
    //   (acc, optionItem, index) => (acc !== -1
    //     ? acc
    //     : (
    //       tv4.validate(formData, optionItem)
    //         ? index
    //         : -1
    //     )),
    //   -1,
    // )(options)
    // @TODO:TEST_END
    const {
      rootSchema
    } = this.props.registry;
    const option = getMatchingOption(formData, options, rootSchema);

    if (option !== -1) {
      return option;
    } // If the form data matches none of the options, use the currently selected
    // option, assuming it's available; otherwise use the first option


    return this && this.state ? this.state.selectedOption : 0;
  }

  render() {
    var _options$selectedOpti;

    const {
      baseType,
      disabled,
      errorSchema,
      formData,
      idPrefix,
      idSchema,
      onBlur,
      onChange,
      onFocus,
      options,
      registry,
      uiSchema,
      schema
    } = this.props;
    const _SchemaField = registry.fields.SchemaField;
    const {
      widgets
    } = registry;
    const {
      selectedOption
    } = this.state;

    const _getUiOptions = getUiOptions(uiSchema),
          {
      widget = 'select'
    } = _getUiOptions,
          uiOptions = _objectWithoutProperties(_getUiOptions, ["widget"]);

    const Widget = getWidget({
      type: 'number'
    }, widget, widgets);
    const option = (_options$selectedOpti = options[selectedOption]) !== null && _options$selectedOpti !== void 0 ? _options$selectedOpti : null;
    let optionSchema;

    if (option) {
      // If the subschema doesn't declare a type, infer the type from the
      // parent schema
      optionSchema = option.type ? option : _objectSpread(_objectSpread({}, option), {}, {
        type: baseType
      });
    }

    const optionNameList = getOptionNameList(options);
    const enumOptions = options.map((option, index) => ({
      label: optionNameList[index],
      value: index
    }));
    return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View // className="form-group"
    , {
      style: {
        marginBottom: 5
      }
    }, /*#__PURE__*/React.createElement(Widget, _extends({
      id: `${idSchema.$id}${schema.oneOf ? '__oneof_select' : '__anyof_select'}`,
      schema: {
        type: 'number',
        default: 0
      },
      onChange: this.onOptionChange,
      onBlur: onBlur,
      onFocus: onFocus,
      value: selectedOption,
      options: {
        enumOptions
      },
      required: true
    }, uiOptions))), option !== null && /*#__PURE__*/React.createElement(_SchemaField, {
      schema: optionSchema,
      uiSchema: uiSchema,
      errorSchema: errorSchema,
      idSchema: idSchema,
      idPrefix: idPrefix,
      formData: formData,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      registry: registry,
      disabled: disabled,
      noFieldTemplate: true
    }));
  }

}

AnyOfField.defaultProps = {
  disabled: false,
  errorSchema: {},
  idSchema: {},
  uiSchema: {}
}; // if (process.env.NODE_ENV !== "production") {
//   AnyOfField.propTypes = {
//     options: PropTypes.arrayOf(PropTypes.object).isRequired,
//     baseType: PropTypes.string,
//     uiSchema: PropTypes.object,
//     idSchema: PropTypes.object,
//     formData: PropTypes.any,
//     errorSchema: PropTypes.object,
//     registry: types.registry.isRequired,
//   };
// }

export default AnyOfField;